import { Directive, Input, OnChanges, SimpleChanges, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
    selector: '[requiredif]',
    providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => RequiredIfValidatorDirective), multi: true }],
    standalone: false,
})
export class RequiredIfValidatorDirective implements Validator, OnChanges {
    @Input() requiredif: boolean;
    private currentValue: boolean;
    private _control: AbstractControl;

    ngOnChanges(changes: SimpleChanges): void {
        const change = changes['requiredif'];
        if (change) {
            this.currentValue = change.currentValue;
            if (this._control) {
                setTimeout(() => this._control.setValue(this._control.value, { emitEvent: true }));
            }
        }
    }

    validate(control: AbstractControl): { [key: string]: any } {
        this._control = control;
        if (this.currentValue && control.value === null) {
            return { requiredif: true };
        }

        return null;
    }
}
